import { Box } from '@mui/material';
import React from 'react';

interface IRankLabelSwitch {
   rank: number;
   labelOf: 'cnRank' | 'candidRank';
}

const RankLabelSwitch = ({ rank, labelOf }: IRankLabelSwitch) => {
   const getBgImage = () => {
      if (rank === 1) {
         return labelOf === 'cnRank'
            ? 'url(/images/charityRanking/cn1.png)'
            : 'url(/images/charityRanking/candid1.png)';
      }
      if (rank === 2) {
         return labelOf === 'cnRank'
            ? 'url(/images/charityRanking/cn2.png)'
            : 'url(/images/charityRanking/candid2.png)';
      }
      if (rank === 3) {
         return labelOf === 'cnRank'
            ? 'url(/images/charityRanking/cn3.png)'
            : 'url(/images/charityRanking/candid3.png)';
      }
      if (rank === 4) {
         return labelOf === 'cnRank'
            ? 'url(/images/charityRanking/cn4.png)'
            : 'url(/images/charityRanking/candid4.png)';
      }
      return undefined;
   };

   return (
      <Box
         sx={{
            width: 80,
            height: 80,
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundImage: getBgImage(),
         }}
      />
   );
};

export default RankLabelSwitch;
